import { createBehavior } from '@area17/a17-behaviors';

const marquee = createBehavior(
  'marquee',
  {
    resolveDurationFromWidth() {
      this.duration = this.width / this.options.speed;
      this.$node.style.setProperty('--duration', `${this.duration}s`);
    },
  },
  {
    init() {
      this.options.speed = this.options.speed
        ? parseInt(this.options.speed, 10)
        : 300;
      this.width = parseInt(this.$node.getBoundingClientRect().width, 10);
      this.resolveDurationFromWidth();
      this.$outer = this.$node.closest('[data-marquee-outer]'); // optional outer node

      this.observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          this.width = parseInt(entry.contentRect.width, 10);
          this.resolveDurationFromWidth();
        }
      });
      this.observer.observe(this.$node);
    },
    destroy() {
      this.observer.unobserve(this.$node);
    },
  }
);

export default marquee;
